import React, { Dispatch, SetStateAction, useState } from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { translate } from '../../../services/translate';
import MyAppText from '../../../components/MyAppText';
import PauseReasonsDropdown from '../../../components/app-agent/PauseReasonsDropdown';
import { appAgentService } from '../../../services/central-api/app-agent';
import Toast from 'react-native-toast-message';
import { ClientError } from '../../../services/central-api/base-service';
import BasicModal from '../../../components/BasicModal';

interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: Dispatch<SetStateAction<boolean>>;
    pauseReason: number;
    setPauseReason: Dispatch<SetStateAction<number>>;
    onClose: () => void;
    unit: AppAgentUnit;
}

export default function OperationalPauseModal({ isModalVisible, setModalVisible, pauseReason, setPauseReason, unit, onClose }: ModalProps) {
    const { styles } = useStyles(styleSheet);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    async function pauseUnit() {
        try {
            setIsLoading(true);
            if (unit) {
                await appAgentService.pauseUnpauseUnit(unit.id, unit.paused ? 'unpause' : 'pause', pauseReason);
                Toast.show({
                    type: 'sentinelxSuccess',
                    text1: translate('ActionSuccessfully'),
                });
                setPauseReason(0);
                setModalVisible(false);
            }
            onClose();
        } catch (err) {
            if (err instanceof ClientError) {
                return Toast.show({
                    type: 'sentinelxError',
                    text1: translate(err.message),
                });
            }
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('unitOperationalPause')}
            width='small'
            mobileHeight='fill'
            primaryButton={{
                text: translate('pause'),
                disabled: !pauseReason || isLoading,
                onClick: async () => {
                    await pauseUnit();
                }
            }}
        >
            <View style={{ gap: 24 }}>
                <View style={styles.descriptionRow}>
                    <MyAppText style={styles.subheader}>{translate('unitOperationalPauseDescription')}</MyAppText>
                </View>
                <PauseReasonsDropdown
                    setValue={setPauseReason}
                    value={pauseReason}
                    zIndex={2}
                    unitId={unit.id}
                />
            </View>
        </BasicModal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    subheader: {
        fontSize: 14,
        fontWeight: '400',
        flexWrap: 'wrap',
        color: theme.colors.modal.subheader,
    },
    descriptionRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
}));
